import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polygon,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polygon, { points: "11 19 2 12 11 5 11 19", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polygon, { points: "22 19 13 12 22 5 22 19", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Rewind";
const Rewind = memo(themed(Icon));
export {
  Rewind
};
//# sourceMappingURL=rewind.js.map
